import { amlQuestionnaireReducerAtom } from '@capsicum/features/regulations/shared';
import { useSetAtom } from 'jotai';

export const useAmlTermsAndConditions = () => {
	const dispatch = useSetAtom(amlQuestionnaireReducerAtom);

	const onChange = (isChecked: boolean) => {
		dispatch({ isValid: isChecked, stepId: 'TermsAndConditions', type: 'UPDATE_STEP_VALIDITY' });
	};

	return { onChange };
};
